import React from 'react';
import { Exam } from '../types';

interface DailyCASelectionProps {
  tests: Exam[];
  onSelectTest: (examId: string) => void;
  onBack: () => void;
}

const DailyCASelection: React.FC<DailyCASelectionProps> = ({ tests, onSelectTest, onBack }) => {
  const todayDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

  return (
    <div className="min-h-screen bg-transparent py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <button 
          onClick={onBack}
          className="mb-8 flex items-center text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 transition-colors"
        >
          <i className="fas fa-arrow-left mr-2"></i> Back to Home
        </button>

        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-orange-100 dark:bg-orange-950/30 text-orange-600 dark:text-orange-400 rounded-full mb-4">
            <i className="fas fa-calendar-day text-2xl"></i>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Daily Current Affairs</h1>
          <p className="text-slate-500 dark:text-slate-400 mt-2">{todayDate}</p>
          <p className="text-sm text-slate-400 dark:text-slate-500 mt-1">Select your exam target to start the specific CA test</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tests.map((test) => (
            <div 
              key={test.id}
              onClick={() => onSelectTest(test.id)}
              className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-6 cursor-pointer hover:shadow-md hover:border-orange-300 dark:hover:border-orange-500/50 transition-all group relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
                <i className="fas fa-newspaper text-6xl text-orange-500"></i>
              </div>
              
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                   <span className="w-10 h-10 rounded-full bg-orange-50 dark:bg-orange-950/30 text-orange-600 dark:text-orange-400 flex items-center justify-center font-bold">
                     <i className="fas fa-pen-nib"></i>
                   </span>
                   <span className="bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 text-xs px-2 py-1 rounded uppercase font-bold">
                     {test.questions.length} Qs
                   </span>
                </div>
                
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2 group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors">
                  {test.title}
                </h3>
                
                <p className="text-slate-500 dark:text-slate-400 text-sm mb-6 line-clamp-2">
                   Specific current affairs questions.
                </p>

                <button className="w-full py-2 bg-slate-50 dark:bg-slate-700 text-slate-700 dark:text-slate-250 font-bold rounded-lg group-hover:bg-orange-500 group-hover:text-white transition-all">
                  Start Test
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DailyCASelection;